import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BusyServices } from "../commons/busy.service";
import { environment } from "../../environments/environment";

@Injectable()
export class CanDriveService {
  private canDriveBaseURI = "canDrive";
  private canDriveByParkIDURI = "canDrive/getByParkId";
  private canDriveByVehicleIDURI = "canDrive/getByVehicleId";

  constructor(private busy: BusyServices, private http: HttpClient) {}

  getCanDriveByParkID(parkId: number): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .get(
          environment.api.baseUrl + this.canDriveByParkIDURI + `/${parkId}`,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.data) {
            resolve(data.data);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  getCanDriveByVehicleID(vehicleId: string): Promise<any> {
    return new Promise<Object>((resolve, reject) => {
      const _http = this.http
        .get(
          environment.api.baseUrl +
            this.canDriveByVehicleIDURI +
            `/${vehicleId}`,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.data) {
            resolve(data.data);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  createCanDrive(userId: number, vehicleId: number): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const body = {
        cdr_user_id: userId,
        cdr_vehicle_id: vehicleId,
      };

      const _http = this.http
        .post(
          environment.api.baseUrl + this.canDriveBaseURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.canDrives) {
            resolve(data.canDrives);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }

  updateCanDrive(canDriveID: number, canDriveClosed: number): Promise<Object> {
    return new Promise<Object>((resolve, reject) => {
      const body = {
        cdr_id: canDriveID,
        cdr_closed: canDriveClosed,
      };

      const _http = this.http
        .put(
          environment.api.baseUrl + this.canDriveBaseURI,
          body,
          environment.api.config
        )
        .subscribe((data: any) => {
          if (data.canDrives) {
            resolve(data.canDrives);
          } else {
            reject();
          }
        });

      this.busy.setBusy(_http);
    });
  }
}
